var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Right"},[_c('moduleTitle',{attrs:{"title":"烘干塔温度分析"}}),_vm._m(0),_c('div',{staticClass:"separation"}),_c('div',{staticClass:"LineChart"},[_c('Echart',{attrs:{"option":_vm.option}})],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"upperright"},[_c('div',{staticClass:"dryingTower"})])
}]

export { render, staticRenderFns }